export const DEFAULT_PAGE_NUM = 1;
export const DEFAULT_PAGE_SIZE = 15;

export const ALL = 'all';
